module.exports = __webpack_public_path__ + "img/OCB_logo.3ccc9a72.png";